import { NO_VALUE } from '@/components/dashboards'
import { parseDateValue } from '@/utils/dates'

/**
 * A stored date as the Asset board writes it ("Oct 21, 26"), or "--" when the
 * record names no real date.
 *
 * The payload mixes calendar days (a maturity, a covenant test date, a cure
 * deadline: Date columns, sent as "2026-10-21") with instants (a due-at, a last
 * update: sent with a time and zone). `new Date(value)` reads a calendar day as
 * midnight UTC, so a reader in New York saw every maturity a day early (stress
 * test CMP-03). A calendar day prints as itself; an instant prints as the day
 * it fell on for the reader.
 */
export function fmtDate(value: string | null | undefined): string {
  const parsed = parseDateValue(value)
  if (!parsed) return NO_VALUE
  return parsed.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: '2-digit' })
}
